import { AccessDenied } from 'app/cross-cutting-concerns/authentication/components/AccessDenied/AccessDenied';

export const AccessDeniedPage = (): JSX.Element => <AccessDenied />;
